module.exports = __webpack_public_path__ + "img/sensehawk-hero.ff0b8cfc.png";